export enum DateSelectionEnum {
  "None" = 0,
  "Now" = 1,
  "Next" = 2,
  "Custom" = 3
}